import { createReducer, on } from '@ngrx/store';
import { Group } from '../../model/group.model';
import * as GroupActions from '../actions/group.actions';

export interface GroupState {
    groups: Group[] | null;
    loading: boolean;
    error: string | null;
}

export const initialState: GroupState = {
    groups: null,
    loading: false,
    error: null
};

export const groupReducer = createReducer(
    initialState,
    
    // Load Groups
    on(GroupActions.LoadGroups, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    
    on(GroupActions.LoadGroupsSuccess, (state, { groups }) => ({
        ...state,
        groups: groups,
        loading: false,
        error: null
    })),
    
    on(GroupActions.LoadGroupsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error
    }))
);
